module.exports = __webpack_public_path__ + "img/greenwich-g-series-high-angle.ae9e6cc4.png";